'use strict';

const GPIO_OUT_MODE = {
    0x00: 'IO_LOW',
    0x01: 'IO_HIGH',
    0x02: 'IO_PWM',
    0x03: 'IO_FOLLOW',
    0x04: 'IO_REVERSE'
};

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.io_index');
    reader.readUInt8('data.params.mode', value => GPIO_OUT_MODE[value]);
    reader.readUInt32LE('data.params.delay_time');
    reader.readUInt32LE('data.params.duration_time');
    reader.readUInt32LE('data.params.low_time');
    reader.readUInt32LE('data.params.high_time');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_3/common/rule/digit-action-parser.js